import React, { ReactNode, useContext } from 'react'
import withDialog from 'shared/hocs/withDialog'
import flowRight from 'lodash/flowRight'
import Button from '../Button'
import ConfirmIcon from 'assets/icons/done.svg'
import ErrorIcon from 'assets/icons/error.svg'
import WarningIcon from 'assets/icons/warning.svg'
import styled from 'styled-components'
import Box from '../Box'

type SnackbarProps = {
  message: ReactNode
  messageBody: ReactNode
  type: 'success' | 'error'| 'warning'
  onClose: Function
  subText: string
  autohide: boolean
  showSubText?: boolean
  isSubTextHTML?: boolean
}

function Snackbar(props: SnackbarProps) {
  const { onClose, type, messageBody, subText = '', autohide, showSubText = false, isSubTextHTML = false } = props
  const icon = {
    warning: WarningIcon,
    error: ErrorIcon,
    success: ConfirmIcon,
  }[type]
  const label = {
    warning: 'Confirm',
    error: 'Done',
    success: 'Done',
  }[type]

  return (
    <ConfirmDialogBody>
      {!messageBody && <Icon src={icon} $type={type} />}
      {messageBody && <MessageBody>{messageBody}</MessageBody>}
      {type === 'error' && !showSubText && <SubText>Please try again or contact support for help</SubText>}
      {!isSubTextHTML && subText && <SubText>{subText}</SubText>}
      {isSubTextHTML && subText && (
        <SubText>
          <div dangerouslySetInnerHTML={{ __html: subText }} />
        </SubText>
      )}
      {!autohide && (
        <InformationalButton variant="primary" onClick={onClose}>
          {label}
        </InformationalButton>
      )}
    </ConfirmDialogBody>
  )
}

const SnackbarDialog = flowRight(withDialog())(Snackbar)

const MessageBody = styled(Box)`
  font-family: Roboto;
  padding: 28px 40px 0;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 18px;
`

const ConfirmDialogBody = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Icon = styled.img<{ $type: string }>`
  margin: 40px auto ${({ $type }) => ($type === 'error' ? '30px' : '40px')};
`

const InformationalButton = styled(Button)`
  height: 46px;
  width: 120px;
  background: ${({ theme }) => theme.colors.main};
  margin-bottom: 40px;
`

const SubText = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  margin-bottom: 30px;
  text-align: center;
  padding: 0 40px;
`

SnackbarDialog.defaultProps = {
  title: 'Confirmation',
  dialogActionsRenderer: null,
  dialogContainerClassName: 'snackbar',
  dialogClassName: 'snackbar-dialog',
}

export default SnackbarDialog
